// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global handorgel, google, YT */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),

        /**
         * Initialise theme JS on page load
         */
        init: () => {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for (const prop in wntrTheme) {
                if (prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },

        /**
         * Breadcrumbs archive translations 
         */
        __bcArchiveTranslation: () => {
            if (wntrTheme.body.hasClass('post-type-archive-news')) {
                const lang = $('html').attr('lang');

                if (lang === 'tr-TR') {
                    wntrTheme.body.find('.breadcrumbs .current-item').text('Haberler');
                } else if (lang === 'ru-RU') {
                    wntrTheme.body.find('.breadcrumbs .current-item').text('Новости');
                }
            }
        },

        /**
         * Print Fares
         */
        __printFares: () => {
            wntrTheme.body.find('.fares__meta-print-button').on('click', function () {
                $(this).closest('.handorgel__content').addClass('currently-printing');
                $(this).closest('.handorgel__content').prev().addClass('currently-printing');
                window.print();
            });

            const beforePrint = function() {
            };
        
            const afterPrint = function() {
                wntrTheme.body.find('.handorgel__header').removeClass('currently-printing');
                wntrTheme.body.find('.handorgel__content').removeClass('currently-printing');
            };
        
            if (window.matchMedia) {
                const mediaQueryList = window.matchMedia('print');
                mediaQueryList.addListener(function(mql) {
                    if (mql.matches) {
                        beforePrint();
                    } else {
                        afterPrint();
                    }
                });
            }
        
            window.onbeforeprint = beforePrint;
            window.onafterprint = afterPrint;
        },

        /**
         * Check if mouse is used
         */
        __checkIfMouseIsUsed: () => {
            // Let the document know when the mouse is being used
            document.body.addEventListener('mousedown', function() {
                document.body.classList.add('using-mouse');
            });
            // Re-enable focus styling when Tab is pressed
            document.body.addEventListener('keydown', function(event) {
                if (event.keyCode === 9) {
                    document.body.classList.remove('using-mouse');
                }
            });
        },

        /**
         * Toggle header background color on scroll
         */
        __toggleHeaderBackground: () => {
            let scrollTimeout = null;
            const throttle = 50;

            toggleHeaderBackgroundClass();

            // Simple scroll throttle
            $(window).on('scroll', function () {
                if (!scrollTimeout) {
                    scrollTimeout = setTimeout(function () {
                        toggleHeaderBackgroundClass();
                        scrollTimeout = null;
                    }, throttle);
                }
            });

            function toggleHeaderBackgroundClass() {
                const scroll_length = wntrTheme.body.find('.global-info-banner--header').length > 0 ? 80 : 15;
                const scroll = $(window).scrollTop();
                
                if (scroll >= scroll_length) {
                    wntrTheme.body.addClass('header--solid');
                } else {
                    wntrTheme.body.removeClass('header--solid');
                }
            }
        },

        /**
         * Initialize video banner
         */
        __initVideoBanner: () => {
            const videoBanner = wntrTheme.body.find('.image-banner--video');

            if (videoBanner.length > 0) {
                const videoDismiss = videoBanner.find('.video-dismiss');

                // Instantiate YouTube iFrame API
                $('script:first-of-type').after($('<script/>').attr('id', 'youtube-embed').attr('src', 'https://www.youtube.com/iframe_api'));
                wntrTheme.videoPlayer = null;
                window.onYouTubeIframeAPIReady = function() {
                    wntrTheme.videoPlayer = new YT.Player('video-embed', {
                        videoId: videoBanner.find('.video-background').data('video'), // This is the YouTube ID from WordPress
                        playerVars: {
                            modestbranding: true,
                            showinfo: 0,
                            rel: 0,
                            controls: 0
                        },
                        events: {
                            'onReady': function() {
                                videoBanner.addClass('video-ready');
                            },
                            'onStateChange': function(event) {
                                if (event.data === 0) {
                                    videoDismiss.trigger('click');
                                }
                            }
                        }
                    });
                };

                // Start the video when play button is clicked
                videoBanner.find('.video-play').click(function() {
                    videoBanner.addClass('image-banner--video-playing').find('.image-banner__inner').fadeTo(300, 0);
                    videoDismiss.fadeIn();
                    wntrTheme.videoPlayer.playVideo();
                });

                videoDismiss.click(function() {
                    videoBanner.removeClass('image-banner--video-playing').find('.image-banner__inner').fadeTo(300, 1);
                    $(this).fadeOut();
                    wntrTheme.videoPlayer.pauseVideo();
                });

                $('.video-background').find('video').attr('playsinline', true);
                setTimeout(function() {
                  $('.video-background').find('video').get(0).play();
                }, 500);
            }
        },

        /**
         * Toggle header
         */
        __toggleHeader: () => {
            // Toggle main header
            const toggleHeaderButton = wntrTheme.body.find('.header__toggle-menu');

            toggleHeaderButton.on('click', function() {
                if (wntrTheme.body.hasClass('header--mobile-menu-active')) {
                    wntrTheme.body.removeClass('body--fixed');
                    wntrTheme.body.removeClass('header--mobile-menu-active');
                    $(this).removeClass('is-active');
                    wntrTheme.document.scrollTop(wntrTheme.current_position);
                } else {
                    wntrTheme.body.addClass('header--mobile-menu-active');
                    $(this).addClass('is-active');

                    // Save current position from top
                    wntrTheme.current_position = wntrTheme.document.scrollTop();
                    // SetTimeout till the css animation has ended
                    setTimeout(function() {
                        wntrTheme.body.addClass('body--fixed');
                    }, 200);
                }
            });

            $(document).keyup(function(e) {
                if (e.keyCode === 27 && wntrTheme.body.hasClass('header--mobile-menu-active')) {
                    wntrTheme.body.removeClass('header--mobile-menu-active');
                    wntrTheme.body.removeClass('body--fixed');
                }
            });

            // Toggle sub menu
            if ($(window).width() < 1100) {
                const toggleSubMenuButton = wntrTheme.body.find('.header__toggle-sub-menu');

                toggleSubMenuButton.on('click', function() {
                    const btn = $(this);
                    btn.toggleClass('is--active');
                    btn.closest('.menu-item-has-children').find('.sub-menu').slideToggle('fast');
                });

                // Check if we're on an subpage
                const active_sub_menu = wntrTheme.body.find('li.active .sub-menu');
                if (active_sub_menu.length > 0) {
                    active_sub_menu.closest('.menu-item-has-children').find('.header__toggle-sub-menu').addClass('is--active');
                    active_sub_menu.css('display', 'block');
                }
            } else {
                const hover_submenu_item = wntrTheme.body.find('li.menu-item-has-children');
                wntrTheme.body.find('.header__toggle-sub-menu').attr('tabindex', '-1');

                hover_submenu_item.on('mouseover', function() {
                    wntrTheme.body.addClass('header--submenu-active');
                });

                hover_submenu_item.on('mouseout', function() {
                    wntrTheme.body.removeClass('header--submenu-active');
                });

                wntrTheme.body.find('li.menu-item-has-children > a').on('focus', function() {
                    wntrTheme.body.addClass('header--submenu-active');
                });

                wntrTheme.body.find('.sub-menu li:last-of-type > a').on('keydown', function(event) {
                    if (event.shiftKey && event.keyCode === 9) {
                        wntrTheme.body.addClass('header--submenu-active');
                    } else if (event.keyCode === 9) {
                        wntrTheme.body.removeClass('header--submenu-active');
                    }
                });
            }
        },

        /**
         * Do match height
         */
        __doMatchHeight: () => {
            wntrTheme.body.find('.card__inner h3').matchHeight();
            wntrTheme.body.find('.card__inner p').matchHeight();
            wntrTheme.body.find('.news-preview__card h3').matchHeight();
        },

        /**
         * Init accordions
         */
        __initAccordions: () => {
            if (wntrTheme.body.find('.timetables').length > 0) {
                new handorgel(document.querySelector('.timetables'));
            }

            if (wntrTheme.body.find('.rates').length > 0) {
                new handorgel(document.querySelector('.rates'));
            }

            if (wntrTheme.body.find('.accordions').length > 0) {
                new handorgel(document.querySelector('.accordions'));
            }
        },

        /**
         * Init Google Maps
         */
        __initGoogleMaps: function() {
            const map_wrapper = wntrTheme.body.find('.card__map');

            if (map_wrapper.length > 0) {
                $.each(map_wrapper, function() {
                    const el = $(this);

                    const map = new google.maps.Map(el[0], {
                        zoom: 13,
                        disableDefaultUI: true,
                        center: new google.maps.LatLng(el.data('lat'), el.data('lng')),
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        gestureHandling: 'cooperative',
                        styles: [
                            {
                                "stylers": [
                                    {
                                        "hue": "#2c3e50"
                                    },
                                    {
                                        "saturation": 250
                                    }
                                ]
                            },
                            {
                                "featureType": "road",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "lightness": 50
                                    },
                                    {
                                        "visibility": "simplified"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            }
                        ]
                    });

                    const infowindow = new google.maps.InfoWindow({
                        content: '<div class="port__info-window"><h2>' + el.data('title') + '</h2><a href="' + el.data('link') + '" target="_blank" rel="noopener norefferer" class="link">' + el.data('link-text') + '</a></div>'
                    });

                    const marker = new google.maps.Marker({
                        position: new google.maps.LatLng(el.data('lat'), el.data('lng')),
                        animation: google.maps.Animation.DROP,
                        icon: {
                            url: el.data('marker-url'),
                            size: new google.maps.Size(36, 36),
                        },
                        map: map
                    });

                    marker.addListener('click', function() {
                        infowindow.open(map, marker);
                    });
                });
            }
        },

        /**
         * Filter ports
         */
        __filterPorts: function() {
            const filter_buttons = wntrTheme.body.find('.ports__filter-button');
            const ports = wntrTheme.body.find('.ports .card');

            filter_buttons.on('click', function() {
                const el = $(this);

                filter_buttons.removeClass('ports__filter-button--active');
                el.addClass('ports__filter-button--active');

                ports.removeClass('card--active');
                wntrTheme.body.find('.ports .card[data-card=' + el.data('filter') + ']').addClass('card--active');
            });
        }
    };

    $(document).ready(wntrTheme.init);
})(jQuery);